export const isSsrDebugEnvironmentAllowed = (
    currentEnvironment: string | undefined,
    allowedEnvironments: readonly string[],
): boolean => {
    if (currentEnvironment === undefined) return false;
    return allowedEnvironments.includes(currentEnvironment);
};
